export default {
    list: [],
    total: 0,
    kecGetProjList: []
};
